import type { ChatStoreState } from "./types";

export const selectInboxMessages = (state: ChatStoreState) =>
  state.inbox.messages;
